import req from '@/service/api';
import Store from '@/store/index';
const state = Store.state;
const key = '/brief';
const brief = {
    create(params) {
        return state.auth.authList.isEditer ? req('POST', key + '/create', params) : false;
    },
    modify(params) {
        return state.auth.authList.isEditer ? req('PUT', key + '/modify', params) : false;
    },
    remove(params) {
        return state.auth.authList.isEditer ? req('DEL', key + '/remove', { data: params }) : false;
    },
    getLatest(params) {
        return req('GET', key + '/getLatest', params);
    }
};
export default brief;
